import { render, staticRenderFns } from "./myForm.vue?vue&type=template&id=04655e48"
import script from "./myForm.vue?vue&type=script&lang=js"
export * from "./myForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports